import type {
    MailOrderProviderInfoFragment,
    PharmacyProviderInfoFragment,
    UnknownProviderInfoFragment,
} from '../../graphql/generated/graphql';

export const getProviderName = (
    provider:
        | UnknownProviderInfoFragment
        | MailOrderProviderInfoFragment
        | PharmacyProviderInfoFragment
        | null
        | undefined,
    providerOverrides:
        | {
              name?: string | null;
          }
        | null
        | undefined
): string => {
    if (providerOverrides && providerOverrides.name) {
        return providerOverrides.name;
    }

    if (provider) {
        switch (provider.__typename) {
            case 'MailOrderProvider':
            case 'PharmacyProvider':
                return provider.name || 'Unnamed Provider';
            case 'UnknownProvider':
            default:
                return 'Unknown Provider';
        }
    }

    return 'Unknown Provider';
};
